//@flow
import React from 'react';

type Props = {
  notification: any,
  memberType: string,
  memberId: number,
  isUnread: boolean,
  content: string,
  link: string,
};

export default class NotificationItem extends React.PureComponent<Props> {
  render() {
    const { notification, isUnread, link, content } = this.props;

    return (
      <li className="notification__sub-item">
        <a
          className={`notification__link ${
            isUnread ? 'notification__link--unread' : ''
          }`}
          href={link}
        >
          <div className="notification__sender">
            <img
              src={notification.senderProfileImage}
              className="notification__sender--avatar"
            />
          </div>
          <div className="notification__content">{content}</div>
          <span className="notification__date">{notification.time}</span>
        </a>
      </li>
    );
  }
}
